<template>
  <div class="container">
    <a-tabs :defaultActiveKey="toolTypes.STM" :animated="false" type="card" class="tools">
      <a-tab-pane tab="对称要素" :key="toolTypes.STM" forceRender class="tabPane">
        <div>
          <drag
            v-for="tool in symTools1"
            class="tool"
            :style="{backgroundImage: `url(${tool.url})`, backgroundSize: tool.previewSize || 'contain'}"
            @dragstart="dragStartHandler(tool, ...arguments)"
          />
        </div>
        <div>
          <drag
            v-for="tool in symTools2"
            class="tool"
            :style="{backgroundImage: `url(${tool.url})`, backgroundSize: tool.previewSize || 'contain'}"
            @dragstart="dragStartHandler(tool, ...arguments)"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane tab="晶面要素" :key="toolTypes.AREA" forceRender class="tabPane">
        <drag
          v-for="tool in areaTools"
          class="tool"
          :style="{backgroundImage: `url(${tool.url})`}"
          @dragstart="dragStartHandler(tool, ...arguments)"
        />
      </a-tab-pane>
    </a-tabs>

    <drop @drop="dropHandler">
      <div id="editor" class="editor" :style="{backgroundImage: showWullfNet ? `url(${wulffnetImg})` : 'none'}"></div>
    </drop>

    <div class="controls">
      
      <a-row type="flex" justify="space-between" class="control__item">
        <div>
          <b>对称要素：
            <var v-for="item in symToolsStatistic" v-if="symToolsStatistic.length > 0 && item.count > 0">
              {{item.count > 1 ? item.count : ''}}{{item.label.name}}<sup vi-if="item.label.sup">{{item.label.sup}}</sup>
            </var>
          </b>
        </div>
        <div><b>晶面数：{{areaToolStatistic ? areaToolStatistic.areaCount : 0}}</b></div>
      </a-row>

      <a-checkbox @change="e => this.showWullfNet = e.target.checked" :checked="showWullfNet">显示吴式网</a-checkbox>

      <a-row type="flex" align="middle" class="control__item">
        <a-col :span="6">旋转(deg)</a-col>
        <a-col :span="18">
          <a-row :gutter="20">
            <a-col :span="16">
              <a-slider :min="0" :max="360" v-model="rotateDeg" />
            </a-col>
            <a-col :span="8">
              <a-input-number :min="0" :max="360" :precision="0" v-model="rotateDeg" style="width: 100%" />
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" justify="end" class="control__item" :gutter="10">
        <a-col :span="9">
          <a-button　type="danger" style="width:100%" @click="deleteAllHandler">删除全部要素</a-button>
        </a-col>
        <a-col :span="9">
          <a-button　type="danger" style="width:100%" @click="deleteHandler">删除当前要素</a-button>
        </a-col>
        <a-col :span="6">
          <a-button　type="primary" style="width:100%" @click="mergeHandler">添加到报告</a-button>
        </a-col>
      </a-row>
    </div>

    <div style="width:100%">
      <h4>操作说明：</h4>
      <p>用鼠标拖动上面的图形要素，放置在上图的基圆中，完成后点击导出文件。</p>
    </div>
  </div>
</template>

<script>
import TOOLS, { TOOL_TYPES } from '@/constants/tools'
import { getSymmetryStatisticInfo, getAreasCount } from '@/utils/statistic'
import wulffnet from '@/assets/images/wulffnet.png'

export default {
  imageEditor: null,

  props: {
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 500
    }
  },

  data () {
    return {
      showWullfNet: true,
      wulffnetImg: wulffnet,

      tools: TOOLS,
      toolTypes: TOOL_TYPES,

      // dragging info
      draggingTool: null,
      draggingOffset: { x: 0, y: 0 },
      
      // transform info 
      currentToolIndex: -1,
      x: 0, y: 0,
      rotateDeg: 0,

      // statistic info
      symToolsStatistic: [], // [{ key, count }]
      areaToolStatistic: null  // { areaCount: 0 }
    }
  },

  computed: {
    symTools1 () {
      return this.tools.filter(t => t.type === TOOL_TYPES.STM && !t.key.startsWith('P'))
    },
    symTools2 () {
      return this.tools.filter(t => t.type === TOOL_TYPES.STM && t.key.startsWith('P'))
    },
    areaTools () {
      return this.tools.filter(t => t.type === TOOL_TYPES.AREA)
    }
  },

  watch: {
    x (value) {
      const { imageEditor } = this.$options
      const { activeImage } = imageEditor
      imageEditor.moveImage(value - activeImage.transform.translate.x, 0)
    },
    y (value) {
      const { imageEditor } = this.$options
      const { activeImage } = imageEditor
      imageEditor.moveImage(0, value - activeImage.transform.translate.y)
    },
    rotateDeg (value) {
      const { imageEditor } = this.$options
      imageEditor.rotateImage(value)
    }
  },
  
  mounted () {
    this.initEditor()
  },

  methods: {
    initEditor () {
      const editor = $('#editor').ImageEditor({
        imageUrls: [],
        width: this.width,
        height: this.height,
        padding: 20,
        onImageSelect: (index, image) => {
          this.currentToolIndex = index
          
          this.x = image.transform.translate.x
          this.y = image.transform.translate.y
          this.rotateDeg = image.transform.rotation
        },
        onTransform: (image) => {
          this.x = image.transform.translate.x
          this.y = image.transform.translate.y
          this.rotateDeg = image.transform.rotation
        }
      })
      this.$options.imageEditor = editor
      window.editor = editor
    },

    addTool (key, x, y) {
      console.log('addTool', key, x, y)
      const { imageEditor } = this.$options
      const tool = TOOLS.find(t => t.key === key)
      imageEditor.addImage(tool, x, y, 30, 30)
    },

    removeTool () {
      const { imageEditor } = this.$options
      imageEditor.removeImage(this.currentToolIndex)
    },

    dragStartHandler (tool, transferData, event) {
      this.draggingTool = tool.key
      this.draggingOffset = { x: event.offsetX, y: event.offsetY }
    },

    dropHandler (transferData, event) {
      const { clientX, clientY } = event
      const toolClientPosition = {
        x: clientX - this.draggingOffset.x,
        y: clientY - this.draggingOffset.y
      }

      const rect = $('#editor')[0].getBoundingClientRect()
      const offsetPositionInEditor = {
        x: toolClientPosition.x - rect.x,
        y: toolClientPosition.y - rect.y
      }

      this.addTool(this.draggingTool, offsetPositionInEditor.x, offsetPositionInEditor.y)
      this.draggingTool = null
      this.updateStatisticInfo()
    },

    deleteHandler () {
      this.removeTool()
      this.updateStatisticInfo()
    },

    deleteAllHandler () {
      this.$options.imageEditor.removeAll()
      this.updateStatisticInfo()
    },

    mergeHandler () {
      this.$emit('output' /*, this.$options.imageEditor.mergeImage() */)
    },
    
    updateStatisticInfo () {
      const { imageEditor } = this.$options
      const toolKeys = imageEditor.images.map(i => i.key)
      this.symToolsStatistic = getSymmetryStatisticInfo(toolKeys)
      this.areaToolStatistic = { areaCount: getAreasCount(toolKeys) }
      console.log(getSymmetryStatisticInfo(toolKeys), getAreasCount(toolKeys))
    },

    getProjectionImage () {
      return Promise.resolve(this.$options.imageEditor.mergeImage().toDataURL())
    }
  }
}
</script>

<style scoped>
.container {
  display: inline-block;
  width: 500px;
  margin-top: 12px;
}

.editor {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
  background-position: center center;
  background-size: 460px 460px;
  background-repeat: no-repeat;
  background-color: #e8e8e8;
}

.tools {
  margin-bottom: 10px;
}

.tool {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin: 0 0 0 6px;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

.controls {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: 20px;
  margin-bottom: 10px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.control__item {
  margin-bottom: 8px;
}

.tabPane {
  height: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/Editor.vue